<template>
  <div class="structure-workspace">
    <div class="structure-header">
      <div class="structure-icon">{{ currentTool.icon }}</div>
      <div class="structure-title-section">
        <h2 class="structure-title">{{ currentTool.title }}</h2>
        <p class="structure-subtitle" v-if="currentTool.subtitle">{{ currentTool.subtitle }}</p>
      </div>
    </div>

    <div class="structure-form">
      <!-- 研究关注点 -->
      <div class="structure-field">
        <label class="structure-label">研究关注点</label>
        <textarea
          class="structure-textarea"
          v-model="localForm.focus"
          rows="5"
          placeholder="例如：请重点分析这篇论文的创新点、实验设计和可复现风险。"
          @input="emitFormChange"
        ></textarea>
      </div>

      <!-- 上传论文 PDF -->
      <div class="structure-field">
        <label class="structure-label">上传论文 PDF</label>
        <div class="structure-upload">
          <input type="file" accept=".pdf" @change="$emit('file-upload', $event)" id="structure-file" />
          <label for="structure-file" class="structure-upload-btn">
            <span>选择文件</span>
          </label>
          <span class="structure-filename" v-if="fileName">{{ fileName }}</span>
          <span class="structure-placeholder" v-else>未选择任何文件</span>
        </div>
      </div>

      <!-- 输出语言 -->
      <div class="structure-field">
        <label class="structure-label">输出语言</label>
        <select class="structure-select" v-model="localForm.outputLang" @change="emitFormChange">
          <option value="zh">中文</option>
          <option value="en">英文</option>
        </select>
      </div>
    </div>

    <div class="structure-submit">
      <button
        class="submit-btn structure-run-btn"
        @click="$emit('submit', localForm)"
        :disabled="(!localForm.focus.trim() && !fileName) || isSubmitting"
      >
        <span v-if="!isSubmitting">{{ currentTool.btnText || '开始运行' }}</span>
        <span v-else>处理中...</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StructureWorkspace',
  props: {
    currentTool: {
      type: Object,
      required: true
    },
    isSubmitting: {
      type: Boolean,
      default: false
    },
    structureForm: {
      type: Object,
      default: () => ({ focus: '', outputLang: 'zh' })
    },
    fileName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localForm: {}
    }
  },
  watch: {
    structureForm: {
      handler(val) {
        this.localForm = { ...val }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.localForm = { ...this.structureForm }
  },
  methods: {
    emitFormChange() {
      this.$emit('form-change', this.localForm)
    }
  }
}
</script>

<style scoped>
.structure-workspace {
  flex: 1;
  overflow-y: auto;
  padding: 32px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}
.structure-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e8e8e8;
}
.structure-icon {
  font-size: 48px;
}
.structure-title-section {
  flex: 1;
}
.structure-title {
  font-size: 28px;
  font-weight: bold;
  color: #1a1a2e;
  margin: 0 0 12px 0;
}
.structure-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.6;
}
.structure-form {
  background: white;
  border-radius: 12px;
  padding: 32px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.structure-field {
  margin-bottom: 24px;
}
.structure-field:last-child {
  margin-bottom: 0;
}
.structure-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 8px;
}
.structure-textarea {
  width: 100%;
  padding: 14px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.6;
  resize: vertical;
  transition: all 0.3s ease;
}
.structure-textarea:focus {
  border-color: #667eea;
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.structure-upload {
  display: flex;
  align-items: center;
  gap: 12px;
}
.structure-upload input[type="file"] {
  display: none;
}
.structure-upload-btn {
  display: inline-block;
  padding: 10px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}
.structure-upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}
.structure-filename {
  font-size: 14px;
  color: #667eea;
  font-weight: 500;
}
.structure-placeholder {
  font-size: 14px;
  color: #999;
}
.structure-select {
  width: 200px;
  padding: 10px 14px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}
.structure-select:focus {
  border-color: #667eea;
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.structure-submit {
  text-align: left;
}
.structure-run-btn {
  background: linear-gradient(135deg, #2d5016 0%, #4a7c23 100%);
  color: white;
  padding: 14px 48px;
  font-size: 16px;
  font-weight: 600;
  min-width: 200px;
}
.structure-run-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(45, 80, 22, 0.4);
}
.submit-btn {
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .structure-workspace {
    padding: 16px;
  }
  .structure-form {
    padding: 16px;
  }
}
</style>
